import { Pipe, PipeTransform } from '@angular/core';
import { LegfiCurrencyPipe } from './legfi-currency.pipe';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({name: 'legfiBalance'})
export class LegfiBalancePipe implements PipeTransform
{
    private negativeColor: string = '#080';
    private positiveColor: string = '#000';

    private _sanitizer: DomSanitizer;

    constructor(_sanitizer: DomSanitizer) {
        this._sanitizer = _sanitizer;
    }

    public transform(
            value: any,
            currencyCode: string = 'usd',
            symbolDisplay: 'code' | 'symbol' | 'symbol-narrow' | boolean = 'symbol',
            digits: string = '.2',
            showCurrencyCode?: boolean,
    ) {
        if (typeof currencyCode !== 'undefined' && currencyCode.length > 0) {
            let negative: boolean = false;
            if (value < 0) {
                negative = true;
                value = Math.abs(value);
            }

            const currencyOutput = (new LegfiCurrencyPipe().transform(value, currencyCode, symbolDisplay, digits, showCurrencyCode));

            return this._sanitizer.bypassSecurityTrustHtml(
                    '<span style="color: ' + (negative
                            ? this.negativeColor
                            : this.positiveColor) + ';">' + currencyOutput + '</span>',
            );
        }
    }
}
